/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 7.34.1
 * source: common/price.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as pb_1 from "google-protobuf";
export namespace common.v1 {
    export class Price extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            amount?: number;
            currency?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
                if ("currency" in data && data.currency != undefined) {
                    this.currency = data.currency;
                }
            }
        }
        get amount() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set amount(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get currency() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set currency(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            amount?: number;
            currency?: string;
        }): Price {
            const message = new Price({});
            if (data.amount != null) {
                message.amount = data.amount;
            }
            if (data.currency != null) {
                message.currency = data.currency;
            }
            return message;
        }
        toObject() {
            const data: {
                amount?: number;
                currency?: string;
            } = {};
            if (this.amount != null) {
                data.amount = this.amount;
            }
            if (this.currency != null) {
                data.currency = this.currency;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.amount != 0)
                writer.writeInt64(1, this.amount);
            if (this.currency.length)
                writer.writeString(2, this.currency);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Price {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Price();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.amount = reader.readInt64();
                        break;
                    case 2:
                        message.currency = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Price {
            return Price.deserialize(bytes);
        }
    }
}
